// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__K8PYI"};